module.exports = __webpack_public_path__ + "static/media/technology-school-events.230bf597.png";